import { call, put, takeLatest } from "redux-saga/effects";
import {
  GetSupplyOrderStatusInit,
  GetSupplyOrderStatusSuccess,
  GetSupplyOrderStatusFailure
} from "./GetSupplyOrderStatusSlice";

import { _CALLGETAPI } from "../../../api/apiHandler";
import {
  LOCALSESSIONDATAKEYS,
  SUCCESS
} from "../../../constants/AppConstants";

import i18next from "i18next";
import { handleError } from "../../SagaError";
import { getLocalSessionData } from "../../../utils/Authentication/handleUserSession";
import { _SUPPLY_ORDER_ENDPOINTS } from "../../../constants/AppConstants";

function __SUPPLYORDERSTATUSSERVICE(UID ,deviceId) {
  const endpoint = _SUPPLY_ORDER_ENDPOINTS.GET_SUPPLY_ORDER_STATUS;

  const payload = {
    params: {
      "userId": UID,
      "deviceId": deviceId 
    }
  };

  return _CALLGETAPI(endpoint, payload)
    .then(response => {
        return response;
    })
    .catch((error) => {
        throw error;
    });
}

function* handleSupplyOrderStatus(action) {
  try {
    const deviceId  = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);

    const response = yield call(__SUPPLYORDERSTATUSSERVICE, UID,deviceId);

    (response.actionStatus?.toUpperCase() === SUCCESS)
      ? yield put(GetSupplyOrderStatusSuccess(response))
      : yield* handleError(
          GetSupplyOrderStatusFailure,
          i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")
        );
  } catch (error) {
    yield* handleError(GetSupplyOrderStatusFailure, error.message);
  }
}

export default function* watchGetSupplyOrderStatusService() {
  yield takeLatest(GetSupplyOrderStatusInit.type, handleSupplyOrderStatus);
}
